'use client';

import React from 'react';
import { Dispatch, SetStateAction } from 'react';
import { Swiper as SwiperInstance } from 'swiper/types';

import { CardItemProps } from './CardDetails';

interface DotsProps {
  items: CardItemProps[];
  isActive?: number;
  setActiveCard: Dispatch<SetStateAction<number>>;
  setIsCarouselClicked: Dispatch<SetStateAction<boolean>>;
  swiper: SwiperInstance | null;
}

export const Dots = ({
  items,
  isActive,
  setActiveCard,
  setIsCarouselClicked,
  swiper,
}: DotsProps) => {
  const handleDotClick = (index: number) => {
    setActiveCard(index + 1);
    setIsCarouselClicked(true);
    swiper!.slideTo(index);
  };

  return (
    <div className='flex gap-3'>
      {items.map((_, index) => (
        <React.Fragment key={index}>
          {isActive === index + 1 ? (
            <div
              key={`dot-${index}`}
              data-tracker={`card-position-${index + 1}`}
              onClick={() => handleDotClick(index)}
              className='bg-neutral-N99 h-2 w-2 cursor-pointer rounded-full'
            ></div>
          ) : (
            <div
              key={`dot-${index}`}
              data-tracker={`card-position-${index + 1}`}
              onClick={() => handleDotClick(index)}
              className='bg-neutral-N00 hover:bg-neutral-N99 h-2 w-2 cursor-pointer rounded-full opacity-40 hover:opacity-100'
            ></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
